import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { getParcelDimensionsDisplay } from "@redotech/redo-fulfillment-parcel-common/parcel";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { getParcelName } from "../../utils/outbound-labels-utils";

const catalogEntry = fgColumnEntries["parcel-selection"];

export const ParcelSelectionColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.LEFT,
  renderNormalCell: ({ row }) => {
    const parcels = row.selectedParcels;
    if (!parcels?.length) {
      return <RedoTableTextCell text="No parcel selected" />;
    }
    const names = parcels.map(getParcelName).join(", ");
    const dims = parcels
      .map(getParcelDimensionsDisplay)
      .filter(Boolean)
      .join(", ");
    return <RedoTableTextCell subtext={dims || undefined} text={names} />;
  },
  onClick: (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  },
  width: catalogEntry.defaultWidth,
  // Sorting is name-only; the displayed value includes dimensions but sorting on dimension strings is not useful.
  sort: catalogEntry.sortDirection,
};
